import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderReceivedPopupComponent } from './order-received-popup.component';

const routes: Routes = [{ path: '', component: OrderReceivedPopupComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderReceivedPopupRoutingModule { }
